import type { ReactNode } from 'react';
import { TableCell, type SxProps, type Theme } from '@mui/material';

type DesktopActionCellProps = {
    children?: ReactNode;
    sx?: SxProps<Theme>;
    width?: number | string;
};

export function DesktopActionHeaderCell({ children, sx, width }: DesktopActionCellProps) {
    const baseSx: SxProps<Theme> = {
        whiteSpace: 'nowrap',
        ...(width !== undefined ? { width } : {}),
    };
    const mergedSx = (sx ? [baseSx, sx] : baseSx) as SxProps<Theme>;

    return (
        <TableCell align="center" sx={mergedSx}>
            {children}
        </TableCell>
    );
}

export function DesktopActionCell({ children, sx, width }: DesktopActionCellProps) {
    const baseSx: SxProps<Theme> = {
        whiteSpace: 'nowrap',
        ...(width !== undefined ? { width } : {}),
    };
    const mergedSx = (sx ? [baseSx, sx] : baseSx) as SxProps<Theme>;

    return (
        <TableCell align="center" sx={mergedSx}>
            {children}
        </TableCell>
    );
}